// src/i18n/es/hotelsOverview.ts
// «Instalaciones» (mockup 09, antes «Hoteles») — route /hotels-overview (distinto
// del recurso de administración de hoteles), Dirección.
export const hotelsOverview = {
  name: 'Instalaciones |||| Instalaciones',
  subtitle: 'Cómo resuelve sus llegadas cada instalación del grupo',

  onlyWithArrivals: 'Solo con llegadas',

  table: {
    columns: {
      hotel: 'Instalación',
      arrivalsPerDay: 'Llegadas por día',
      arrivals: 'Llegadas',
      preCheckInDonePct: '% pre-check-in',
      resolvedWithoutReceptionPct: '% por autoservicio',
      kioskCheckIns: 'Check-ins en kiosco o móvil',
      medianKioskSeconds: 'Duración mediana',
      leftMidwayPct: '% a medias en kiosco o móvil',
      charged: 'Cobrado',
    },
  },

  // P02: where each row's arrivals come from, under the installation name.
  source: {
    hotelSystem: 'Llegadas de la lista de reservas del hotel',
    roommatik: 'Reservas con actividad en Roommatik',
  },

  chainAverage: 'Media de los hoteles',

  chartDialog: {
    openAria: 'Ampliar el gráfico de llegadas por día de %{name}',
    title: 'Llegadas por día · %{name}',
    period: 'Del %{from} al %{to}',
    total: 'Total del periodo: %{count} llegada |||| Total del periodo: %{count} llegadas',
    close: 'Cerrar',
  },

  equipment: {
    kiosk: 'Kiosco',
    airLobby: 'Air Lobby',
    online: 'Online',
  },

  help: {
    title: 'Instalaciones',
    description: 'Compara cómo resuelve cada instalación sus llegadas: pre-check-in, autoservicio y cuántos huéspedes se quedan a medias.',
    features: {
      sparkline: 'La columna «Llegadas por día» muestra la tendencia del periodo en miniatura; pulse sobre ella para verla ampliada.',
      onlyWithArrivals: 'Active «Solo con llegadas» para ocultar instalaciones sin movimiento en el periodo.',
      source:
        'Bajo el nombre de cada instalación se indica de dónde salen sus llegadas: la lista de reservas del hotel (sin canceladas ni no presentados) o, si no la comparte, las reservas con actividad en Roommatik. Los porcentajes de la fila son sobre esas llegadas.',
      kiosk: 'Las columnas de kiosco incluyen el check-in en el móvil, que es el mismo recorrido en el teléfono del huésped. Tienen cifra cuando la instalación tiene un kiosco registrado o check-ins en el kiosco o en el móvil en el periodo.',
    },
    tips: {
      dash: 'Una casilla con «—» indica que la cifra no se puede calcular: la instalación no tiene ese equipo o no tuvo llegadas en el periodo. Un cero se muestra como 0.',
    },
  },
};

export default hotelsOverview;
